import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { getProffitSearchValues } from '../../../../helpers/profile';
import { useMemoFrozen } from '../../../../helpers/use/useHook';
import BowserState from '../../../../helpers/window/BowserState';
/**
 * 登録端末の設定用のHoc
 * @param registrationProps
 * @returns {function(*): (function(*): *)|*}
 * @constructor
 */
const ProffitSearchRegistrationDeviceHoc = (registrationProps) => (ChildComponent) => {
    const { isRegistration } = registrationProps || {};
    const ProffitSearchRegistrationDeviceHocInner = (props) => {
        const profile = useSelector((state) => state.profile);
        const userDevice = useSelector((state) => state.proffitSearchDevice.userDevice);
        const redirectTo = useMemoFrozen(() => {
            const { enableProffitSearch, userAllowDeviceId } = getProffitSearchValues(profile);
            const { platform } = BowserState.bowser;
            // 端末登録前
            if (!enableProffitSearch) {
                return '/';
            }
            // 登録用URLからの表示 && 端末割り当て済み
            const hasDevice = userAllowDeviceId && userDevice;
            const isAssigned = userAllowDeviceId === userDevice;
            if (isRegistration && hasDevice && isAssigned) {
                return '/proffit_search';
            }
            // 登録端末が一致しない場合 && (mobile端末 || 登録用URLからの表示ではない)
            if (!isAssigned && (platform.type === 'mobile' || !isRegistration)) {
                return '/proffit_search/registration_device';
            }
            return '';
        });
        if (redirectTo) {
            return _jsx(CustomRedirect, { to: redirectTo });
        }
        return _jsx(ChildComponent, Object.assign({}, props));
    };
    ProffitSearchRegistrationDeviceHocInner.propTypes = {
        match: propMatch(),
    };
    return ProffitSearchRegistrationDeviceHocInner;
};
export default ProffitSearchRegistrationDeviceHoc;
